import React from "react";
import "./NotFound.scss";
import NotFoundComponent from "./NotFoundComponent";

const NotFound = (props: any) => {

  const isSettingsPage = window.location.pathname.split("/")[1] === "settings"

  return (
    <div
      className="not-found-wrapper"
      style={{ height: isSettingsPage ? 'auto' : '100vh' }}
    >
      <NotFoundComponent user={props.user} message={props.message} subMessage={props.subMessage} showSubMessage={true} />
    </div>
  );
};

export default NotFound;
